/**
 * This file was copied from dashboard into clowncar as part of a cleanup effort
 */
import { constants } from '@tock/shared-app-constants';

export default constants([
  'AUTH_REFRESH_FROM_STORAGE',
  'ACCOUNT_ACTIVATION',
  // Application State constants
  'APP_STATE_LOADING',
  // Auto chit printing
  'AUTO_PRINT_CHITS_CHIT_PRINTED',
  'AUTO_PRINT_CHITS_CHIT_PRINT_FAILED',
  'AUTO_PRINT_CHITS_STATUS',
  // Authentication collection constants
  'AUTHENTICATION_CLEARED',
  'AUTHENTICATION_METHODS',
  'AUTHENTICATION_RESPONSE',
  'AUTHENTICATION_RESPONSE_SELF_ONBOARDING',
  'AUTHENTICATION_ROLES_UPDATE',
  'AUTHENTICATION_SET_ACTIVE',
  // Booking release
  'BOOKING_RELEASE_FETCH',
  // Business entity
  'BUSINESS_FETCH',
  'BUSINESS_PACING_FETCH',
  'BUSINESS_PACING_WEEKDAY_FETCH',
  'BUSINESS_DAY_PACING_FETCH',
  'BUSINESS_DAY_PACING_LIST',
  'BUSINESS_ACCOUNT_BALANCE_FETCH',
  'BUSINESS_PLAN_UPDATE',
  'BUSINESS_UPDATE',
  'BUSINESS_UPDATE_LOCAL',
  // Business-level communication policies
  'BUSINESS_POLICIES_FETCH',
  'BUSINESS_POLICIES_UPDATE',
  // Business-level communication policy
  'BUSINESS_COMMUNICATION_POLICY_FETCH',
  'BUSINESS_COMMUNICATION_POLICY_UPDATE',
  // Business details
  'BUSINESS_DETAILS_UPDATE_LOCAL',
  'BUSINESS_DETAILS_PRINT_CHIT_WHEN_SEATING_UPDATE',
  // Business accolades
  'BUSINESS_ACCOLADE_REORDER',
  // Business roles
  'BUSINESS_ROLES_FETCH_ALL',
  'BUSINESS_ROLES_ADD',
  'BUSINESS_ROLES_UPDATE',
  // Business image upload
  'BUSINESS_IMAGE_UPDATE',
  // Business locales
  'BUSINESS_LOCALES_AVAILABLE_UPDATE',
  'BUSINESS_LOCALES_SELECTED_UPDATE',
  // Business payment
  'BUSINESS_PAYMENT_ACCOUNT_UPDATE',
  'BUSINESS_PAYMENT_FETCH',
  'BUSINESS_PAYMENT_SWITCH_TO_BRAINTREE',
  'BUSINESS_PAYMENT_VERIFY_BANK',
  // business server
  'BUSINESS_SERVER_ADD',
  'BUSINESS_SERVER_UPDATE',
  'BUSINESS_SERVER_REMOVE',
  'BUSINESS_SERVER_FETCH',
  // Taxes
  'BUSINESS_TAX_ARCHIVE',
  'BUSINESS_TAX_FETCH',
  'BUSINESS_TAX_UPSERT',
  // WIDGET BUILDER
  'BUSINESS_CONSUMER_WIDGET_TOKEN_FETCH',
  // Scheduled Inventory
  'BUSINESS_INVENTORY_SCHEDULES_FETCH',
  'BUSINESS_INVENTORY_SCHEDULES_FETCH_ALL',
  'BUSINESS_INVENTORY_SCHEDULES_CREATE',
  'BUSINESS_INVENTORY_SCHEDULES_UPDATE',
  'BUSINESS_INVENTORY_SCHEDULES_DELETE',
  'BUSINESS_INVENTORY_SCHEDULES_DUPLICATE',
  'BUSINESS_INVENTORY_SCHEDULES_VALIDATE_DATE_RANGE',
  'BUSINESS_INVENTORY_SCHEDULES_IMPORT_FLOOR_PLAN',
  // Scheduled Inventory Closed Days
  'BUSINESS_CLOSED_DAYS_FETCH',
  'BUSINESS_CLOSED_DAYS_ADD',
  'BUSINESS_CLOSED_DAYS_DELETE',
  // Guest integration locations
  'CLEAR_LOCATIONS',
  // Create account
  'CREATE_ACCOUNT',
  // Cancellation policy
  'CANCELLATION_POLICY_FETCH_ALL',
  'CANCELLATION_POLICY_BUSINESS_UPDATE',
  // Calendar constants
  'CALENDAR_SELECT_ALL_ITEMS',
  'CALENDAR_ADD_RELATED_ITEMS',
  'CALENDAR_REMOVE_RELATED_ITEMS',
  'CALENDAR_DESELECT_ALL_ITEMS',
  'CALENDAR_CLEAR_SELECTED_CALENDAR_ITEM',
  'CALENDAR_SPECIFY_SELECTED_CALENDAR_ITEM',
  'CALENDAR_CLEAR_DATA_FROM_STORE',
  'CALENDAR_ENTITY_UPDATE',
  'CALENDAR_ENTITY_SAVE_DATE',
  'CALENDAR_ENTITY_RESTORE_DATE',
  'CALENDAR_SET_LOADING',
  'CALENDAR_SELECT_TAB',
  'CALENDAR_SET_BOOKING_MODAL_VISIBLE',
  'CALENDAR_SET_SHOW_ACTIONS_MODAL',
  'CALENDAR_SET_SHOW_TICKET_SUBSET_HOLD_MODAL',
  'CALENDAR_SET_SIDE_PANEL_VISIBLE',
  'CALENDAR_SET_DATE',
  'CALENDAR_SET_FRESH',
  'CALENDAR_SET_TEXT_FILTER',
  'CALENDAR_FLEX_SET_RESCHEDULED',
  'CALENDAR_SET_STATE',
  'CALENDAR_SET_SELECTION_MODE',
  'CALENDAR_SET_RESCHEDULE_MODE',
  'CALENDAR_SET_MOVING_TABLE',
  'CALENDAR_STOP_MOVING_TABLE',
  'CALENDAR_SET_CALENDAR_ITEM_TO_HOLD',
  'CALENDAR_SET_SELECTED_INVENTORY_VIEW',
  'CALENDAR_SET_FOCUSED_TIME_SPAN',
  'CALENDAR_RESET_FOCUSED_TIME_SPAN',
  // Day Calendar Filters === Query params passed to server
  'CALENDAR_FILTER_PARAMS_UPDATE',
  'CALENDAR_FILTER_CLEAR',

  'CALENDAR_ITEM_SET_META',
  'CALENDAR_ITEM_CLEAR_META',
  'CALENDAR_SET_SELECTED_TABLE_ID',
  'CALENDAR_SET_SELECTED_TABLE_ID_CALENDAR_SQUARE',
  'SET_SELECTED_TABLE_IDS_TO_BOOK',
  'CLEAR_SELECTED_TABLE_IDS_TO_BOOK',
  'CALENDAR_SET_SELECTED_FLEX_CALENDAR_SQUARE',

  'CALENDAR_CHANGE_TAB',
  'CALENDAR_ACTION',
  'CALENDAR_ITEM_ADD_SELECTION',
  'CALENDAR_ITEM_REMOVE_SELECTION',
  'CALENDAR_SERVICE_SELECTION_SET_SERVICE',

  'CALENDAR_FLOORPLAN_FETCH_FOR_SERVICE_DAY',

  'CHITS_AUTO_PRINT_FOR_ORDER',
  'CHITS_SET_TEXT_PRINT',
  'CHITS_CLEAR_TEXT_PRINT',
  'CHITS_OPEN_PRINT_MULTIPLE_MODAL',
  'CHITS_CLOSE_PRINT_MULTIPLE_MODAL',
  'CHITS_OPEN_CHOOSE_PRINTER_MODAL',
  'CHITS_CLOSE_CHOOSE_PRINTER_MODAL',
  'CHITS_SET_PRINT_FOR_WALKIN_ID',
  'CHITS_CLEAR_PRINT_FOR_WALKIN_ID',

  'CLEAR_TICKET_MENU',

  'DASHBOARD_PREFERENCES_FETCH',
  'DASHBOARD_PREFERENCES_SAVE',

  // Day notes
  'DAY_NOTES_FETCH',
  'DAY_NOTES_TOGGLE_MODAL',
  'DAY_NOTES_SAVE',
  'DAY_NOTES_ENTITY_UPDATE',
  'DAY_NOTES_RESERVATION',

  // Menu categories
  'MENU_CATEGORY_FETCH',
  'MENU_CATEGORY_INSERT',
  'MENU_CATEGORY_UPDATE',

  // Menus
  'MENU_FETCH',
  'MENU_INSERT',
  'MENU_UPDATE',
  'MENU_COPY',

  // Menu sections
  'MENU_SECTION_INSERT',
  'MENU_SECTION_UPDATE',

  // Menu items
  'MENU_ITEM_FETCH',
  'MENU_ITEM_INSERT',
  'MENU_ITEM_UPDATE',
  'MENU_ITEM_MODIFIER_GROUPS_UPDATE',

  // Menu modifier groups
  'MENU_MODIFIER_GROUP_FETCH',
  'MENU_MODIFIER_GROUP_INSERT',
  'MENU_MODIFIER_GROUP_UPDATE',

  // Menu modifier groups to menu items
  'MENU_MODIFIER_GROUP_TO_ITEM_FETCH',
  'MENU_MODIFIER_GROUP_TO_ITEM_INSERT',
  'MENU_MODIFIER_GROUP_TO_ITEM_DELETE',

  // Menu item to menu section
  'MENU_ITEM_TO_SECTION_INSERT',
  'MENU_ITEM_TO_SECTION_DELETE',

  // Ticket Menu
  'TICKET_MENU_GET',
  'TICKET_MENU_REMOVE',
  'TICKET_MENU_UPDATE',

  // Event template
  'TICKET_EVENT_TEMPLATE_INSERT',
  'TICKET_EVENT_TEMPLATE_UPDATE',
  'TICKET_EVENT_TEMPLATES_GET',
  'TICKET_EVENT_TEMPLATE_APPLY',
  'TICKETS_EVENT_TEMPLATES_GET',

  // Flex calendar section manipulation
  'FLEX_CALENDAR_SECTIONS_OPEN_SECTION',
  'FLEX_CALENDAR_SECTIONS_CLOSE_SECTION',
  'FLEX_CALENDAR_SECTIONS_TOGGLE_SECTION',

  'FLEX_CALENDAR_UNASSIGNED_SECTION_OPEN_SECTION',
  'FLEX_CALENDAR_UNASSIGNED_SECTION_CLOSE_SECTION',
  'FLEX_CALENDAR_UNASSIGNED_SECTION_TOGGLE_SECTION',

  // Template section manipulation
  'TEMPLATE_SECTIONS_OPEN_SECTION',
  'TEMPLATE_SECTIONS_CLOSE_SECTION',
  'TEMPLATE_SECTIONS_TOGGLE_SECTION',

  // Blocks & Holds
  'FLEX_BLOCKS_SET',
  'FLEX_BLOCKS_CLEAR',
  'FLEX_HOLD_SET',
  'CALENDAR_ITEM_HOLD_SET',
  'CALENDAR_ITEM_SHOW_SUBSET_MODAL',

  // Guest List
  'GUEST_LIST_SET_SELECTED_GUEST',
  'GUEST_LIST_CLEAR_SELECTED_GUEST',

  // Calendar availability
  'AVAILABILITY_FETCH',
  'AVAILABILITY_SET_PARAMS',
  'AVAILABILITY_SET_MODE',

  // Check in
  'CHECKIN_SCAN',
  'CHECKIN_SCAN_RESULT_CLEAR',
  'CALENDAR_UPDATE_CHECKIN',
  'CHECKIN_DATE_CHANGE',
  'CHECKIN_TOGGLE_EXPAND_STATUS_DETAIL',

  // Delivery
  'CALENDAR_UPDATE_DELIVERY',
  'DELIVERY_DATE_CHANGE',
  'ASSIGN_DELIVERY',

  // Email opt-in
  'COMMUNICATION_OPTIN_EXPORT',
  'COMMUNICATION_OPTIN_SET_REQUESTS_OPTIN',

  // Tokenize payment card.
  'PAYMENT_CARD_TOKENIZE',
  'BANK_ACCOUNT_TOKENIZE',

  // Finance tools
  'FINANCE_STRIPE_PAYMENTS_REPORT',

  // Month Calendar constants
  'MONTH_CALENDAR_FETCH_ALL',
  'MONTH_CALENDAR_SET_CURRENT',
  'MONTH_CALENDAR_ENTITY_UPDATE',
  // Download constants
  'DOWNLOAD',
  // Entity modal constants
  'ENTITY_MODAL_CLOSE_DIALOG',
  'ENTITY_MODAL_OPEN_DIALOG',
  'ENTITY_MODAL_CLOSE',
  'ENTITY_MODAL_OPEN',
  'ENTITY_MODAL_OPEN_WITH_ENTITY',
  'ENTITY_MODAL_UPDATE',
  // Hand Sell Constants
  'HAND_SELL_UPDATE_PROMOCODE',
  'HAND_SELL_UPDATE_GRATUITY',
  'HAND_SELL_CUSTOM_CHARGE_ADD',
  'HAND_SELL_CUSTOM_CHARGE_REMOVE',
  'HAND_SELL_PROMOCODE_LIST',
  'HAND_SELL_PROMOCODE_ELIGIBLITY',
  'HAND_SELL_CALCULATE_PRICE',
  'HAND_SELL_CLEAR_ALL',
  'HAND_SELL_CLEAR_PAYMENT_CARD',
  'HAND_SELL_CLEAR_COMPLETED_PURCHASE',
  'HAND_SELL_CLEAR_COMPLETED_PURCHASE_EMAIL',
  'HAND_SELL_EDIT',
  'HAND_SELL_GIFT_CARD_APPLY',
  'HAND_SELL_GIFT_CARD_REMOVE',
  'HAND_SELL_LOCK',
  'HAND_SELL_UNLOCK',
  'HAND_SELL_OPEN',
  'HAND_SELL_PURCHASE',
  'HAND_SELL_PURCHASE_EMAIL',
  'HAND_SELL_PURCHASE_SMS',
  'HAND_SELL_GET_PATRON_TOKEN',
  'HAND_SELL_UPDATE_AVAILABILITY',
  'HAND_SELL_UPDATE_BOOKING_NOTE',
  'HAND_SELL_UPDATE_COMP_AMOUNT',
  'HAND_SELL_UPDATE_DELIVERY_INFORMATION',
  'HAND_SELL_UPDATE_POST_TOTAL_ADMIN_COMP_AMOUNT',
  'HAND_SELL_UPDATE_CHECKED_QUESTIONS',
  'HAND_SELL_UPDATE_DATE_TIME',
  'HAND_SELL_UPDATE_EXCLUDE_FROM_PACING',
  'HAND_SELL_UPDATE_TURN_TIME',
  'HAND_SELL_UPDATE_DIETARY_NOTE',
  'HAND_SELL_UPDATE_EXPERIENCE',
  'HAND_SELL_UPDATE_FREEFORM_QUESTIONS',
  'HAND_SELL_UPDATE_LOCK_DURATION',
  'HAND_SELL_CLEAR_LOCK_DURATION',
  'HAND_SELL_UPDATE_NUM_TICKETS',
  'HAND_SELL_UPDATE_OPTIONS',
  'HAND_SELL_UPDATE_PATRON',
  'HAND_SELL_UPDATE_PAYMENT_CARD',
  'HAND_SELL_UPDATE_REFUND_TYPE',
  'HAND_SELL_CLEAR_REFUND_TYPE',
  'HAND_SELL_UPDATE_RESCHEDULE_OPTIONS',
  'HAND_SELL_UPDATE_TYPE',
  'HAND_SELL_UPDATE_EMAIL_POLICY',
  'HAND_SELL_FETCH_GUEST_PROFILE',
  'HAND_SELL_UPDATE_GUEST_NOTES',
  'HAND_SELL_CLEAR_GUEST_NOTES',
  'HAND_SELL_CLEAR_GUEST_TAGS',
  'HAND_SELL_UPDATE_GUEST_PROFILE_NOTE',
  'HAND_SELL_CLEAR_GUEST_PROFILE',
  'HAND_SELL_RESET',
  'HAND_SELL_UPDATE_VISIT_TAGS',
  'HAND_SELL_UPDATE_GUEST_TAGS',
  'HAND_SELL_SET_KEY_VALUES',
  'HAND_SELL_CLEAR_KEY_VALUES',
  'HAND_SELL_INCREASE_SIZE_FLAG',
  'HAND_SELL_UPDATE_AVAILABLE_OPTIONS',
  // HUB LANDING
  'HUB_LANDING_FETCH_DAILY_COVERS',
  'HUB_LANDING_FETCH_DAILY_LARGE_PARTIES',
  // Guest Profile Search (Directory)
  'GUEST_PROFILE_SEARCH',
  'GUEST_PROFILE_GET',
  // Keyboard shortcuts
  'KEYBOARD_SHORTCUTS_CLOSE_MODAL',
  'KEYBOARD_SHORTCUTS_OPEN_MODAL',

  // MetaTag
  'METATAG_FETCH',
  // Notes constants
  'NOTES_FETCH_ALL',
  'NOTES_ADD',
  'NOTES_DELETE',
  'NOTES_UI_UPDATE',
  // Options collection constants
  'OPTIONS_FETCH_ALL',
  'OPTIONS_ADD',
  'OPTIONS_UPDATE',
  // Constants for creating or editing options
  'ONE_OPTION_UPDATE',
  // Onboarding
  'ONBOARDING_CREATE_BUSINESS',
  'ONBOARDING_DOMAIN_CHECK',
  'ONBOARDING_FETCH_NEW_ROLES',
  'ONBOARDING_FETCH_TIME_ZONE_DONE',
  'ONBOARDING_GET_AUTH',
  'ONBOARDING_GET_BUSINESS',
  'ONBOARDING_SAVE_TOS',
  'ONBOARDING_SAVE_TOS_ADDON',
  'ONBOARDING_SIGNUP',
  'ONBOARDING_STEPS_FETCH',
  'ONBOARDING_UPDATE_COMPLETED_STEP',
  'ONBOARDING_UPDATE_STORE_STATE',
  'ONBOARDING_STORE_SET_REFRESH_ONBOARDING',
  // Order notifications
  'ORDER_NOTIFICATIONS_CALENDAR_ENTITY_UPDATE',
  'ORDER_NOTIFICATIONS_PLAY_SOUND',
  'ORDER_NOTIFICATIONS_SOUND_PLAYED',
  'ORDER_NOTIFICATIONS_SOUND_PLAY_FAILED',
  'ORDER_NOTIFICATIONS_QUEUE_ALERT',
  'ORDER_NOTIFICATIONS_DISMISS_ALERT',
  // Lockout
  'OVERRIDE_LOCKOUT',

  'RESCHEDULE_SET_RESCHEDULED',
  'RESCHEDULE_CLEAR_RESCHEDULED',
  'RESCHEDULE_SET_RESCHEDULE_TO',
  'RESCHEDULE_CLEAR_RESCHEDULE_TO',

  //Schedule
  'RESOLVE_SCHEDULE_DATES',

  // Self Onboarding
  'SELF_ONBOARDING_HELP_SUBMIT',
  'SELF_ONBOARDING_CREATE',
  'SELF_ONBOARDING_LEAD',
  'EMAIL_LOOKUP',
  'SELF_ONBOARDING_CREATE_EVENT',
  'SELF_ONBOARDING_CLEAR_DATA',
  'SELF_ONBOARDING_SAVE_BUSINESS_INFO',
  'SELF_ONBOARDING_SAVE_EVENT_TEMPLATE',
  // Party size for sold tables, max table size for unsold
  'SIZES_FETCH_ALL',

  // Supplements
  'SUPPLEMENTS_REORDER',

  // Supplement groups
  'SUPPLEMENT_GROUPS_REORDER',
  'SUPPLEMENT_GROUP_COPY',
  'SUPPLEMENT_COPY',

  // Supplement Modifiers
  'SUPPLEMENT_MODIFIER_UPSERT',
  'SUPPLEMENT_MODIFIERS_REORDER',

  // Package
  'PACKAGE_ADD',
  'PACKAGE_UPDATE',
  'PACKAGE_DELETE',
  'PACKAGE_FETCH_ALL',
  // Passcode config
  'PASSCODE_CONFIG_FETCH',
  'PASSCODE_CONFIG_UPDATE',
  // Patron Details
  'PATRON_DIETARY_NOTE_UPDATE',
  'PATRON_NOTE_UPDATE',
  // Logged in user profile
  'PATRON_FETCH_LEGACY_TRANSFERS',
  'PATRON_FETCH_PROFILE',
  'PATRON_SET_PROFILE',
  // Passcode for patron, scoped to business
  'PATRON_PASSCODES_FETCH',
  'PATRON_PASSCODES_UPSERT',
  'PATRON_PASSCODES_DELETE',
  // POS related constants
  'POS_SEARCH_CHECKS',
  'POS_CONNECT',
  'POS_CONNECT_UPDATE',
  'POS_LIST_CONNECTED',
  'POS_SEARCH_DAY_VISITS',
  'POS_ASSOCIATE_CHECK',
  'POS_EXCLUDE_CHECK',
  'POS_UPDATE_PARTY_STATUS',
  'POS_RESEND_UPDATE_PARTY_STATUS',

  // PRINTERS
  'SAVED_PRINTERS_CREATE',
  'SAVED_PRINTERS_DESTROY',
  'SAVED_PRINTERS_FETCH_ALL',
  'SAVED_PRINTERS_RESET',
  'SAVED_PRINTERS_REORDER',
  'NETWORK_PRINTERS_DO_NOT_SHOW_PROGRESS',
  'NETWORK_PRINTERS_FETCH_ALL',
  'NETWORK_PRINTERS_FIND',
  'NETWORK_PRINTERS_SUBMIT',
  'NETWORK_PRINTERS_JOB',

  // Purchase related constants
  'PURCHASE_CANCEL',
  'PURCHASE_CANCEL_CLEAR',
  'PURCHASE_CANCEL_OPEN',
  'PURCHASE_CANCEL_UPDATE',
  'PURCHASE_REFUND',
  'PURCHASE_REFUND_CLEAR',
  'PURCHASE_REFUND_UPDATE',
  'PURCHASE_REFUND_UPDATE_PURCHASE_ORDER',
  'PURCHASE_COMP_OPEN',
  'PURCHASE_TRANSFER',
  'PURCHASE_TRANSFER_OPEN',
  'PURCHASE_TRANSFER_CLEAR',
  'PURCHASE_FETCH_TIMELINE_EVENTS',
  // Service reports.
  'REPORT_SET_DATA',
  'REPORT_SUBSCRIPTION_FETCH',
  'REPORT_TABLES_FETCH',
  'REPORT_TABLES_REPORT_HAS_EXPERIENCE_SELECTED',
  'REPORT_TRANSACTIONS_FETCH',
  'REPORT_REDEMPTIONS_FETCH',
  'REPORT_FEEDBACK_FETCH',
  'REPORT_GUESTS_FETCH',
  'REPORT_TABLE_MANAGEMENT_FETCH',
  'REPORT_WAITLISTS_FETCH',
  'REPORT_WAITLISTS_ADD_ITEM',
  'REPORT_WAITLISTS_DELETE_ITEM',
  'REPORT_WAITLISTS_EDIT_ITEM',
  'SET_BOOKINGS_REPORT_FILTERS',
  'SET_WAITLIST_REPORT_FILTER',
  'SET_WAITLIST_REPORT_TEXT_FILTER',
  // Public hours collection constants
  'PUBLIC_HOURS_CREATE',
  'PUBLIC_HOURS_DELETE',
  'PUBLIC_HOURS_UPDATE',
  'PUBLIC_HOURS_FETCH_ALL',
  'PUBLIC_HOURS_INITIALIZE_FROM_SERVICES',
  // Services collection constants
  'SERVICES_CREATE',
  'SERVICES_DELETE',
  'SERVICES_UPDATE',
  'SERVICES_FETCH_ALL',
  // Service type constants
  'SERVICE_TYPES_FETCH_ALL',
  // Table edits
  'TABLE_EDITS_INITIALIZE',
  'TABLE_EDITS_UPDATE_TABLE_LOCATION',
  // Tickets collection constants
  'ACTIVE_TICKETS_FETCH_ALL',
  'TICKETS_ADD',
  'TICKETS_COMMUNICATION_POLICY_FETCH',
  'TICKETS_COMMUNICATION_POLICY_UPDATE',
  'TICKETS_FETCH_ALL',
  'TICKETS_FETCH_SINGLE',
  'TICKETS_REORDER',
  'TICKETS_SAVE_ORDERING',
  'TICKETS_SELECT_FROM_LIST',
  'TICKETS_SURVEY_REORDER',
  'TICKETS_SURVEY_UPDATE',
  'TICKETS_UPDATE',
  'TICKETS_UPDATE_ALL',
  'TICKETS_UPDATE_EVENT_DATE',
  'TICKET_PROMOTION_FETCH_ALL',
  'TICKET_PROMOTION_INSERT',
  'TICKET_PROMOTION_UPDATE',
  // Ticket group constants
  'TICKET_GROUPS_ADD',
  'TICKET_GROUPS_LOCKED',
  'TICKET_GROUPS_UNLOCKED',
  'TICKET_GROUPS_UPDATE',
  'TICKET_GROUPS_DELETED',
  'TICKET_GROUPS_HAND_SELL_DELETED',
  // Ticket group rescheduling
  'TICKET_GROUPS_SET_RESCHEDULED',
  // Ticket group related.
  'TICKET_GROUPS_SHOW_DETAILS',
  'TICKET_GROUPS_SHOW_MODIFY_CALENDAR_ITEM',
  'TICKET_GROUPS_SHOW_TICKET_SUBSET_HOLD',
  'TICKET_GROUPS_TICKET_SUBSET_UPDATE',
  // Constants for creating or editing tickets
  'ONE_TICKET_UPDATE',
  // Templates
  'TEMPLATE_FETCH_ALL',
  'TEMPLATE_ADD',
  'TEMPLATE_UPDATE',
  'TEMPLATE_DELETE',
  'TEMPLATE_DUPLICATE',
  'TEMPLATE_INFO_DETAILS_FETCH_ALL',
  // Template info
  'TEMPLATE_INFO_FETCH_TEMPLATE',
  'TEMPLATE_INFO_FETCH_ALL',
  'TEMPLATE_INFO_ADD',
  'TEMPLATE_INFO_RESET_TABLES',
  'TEMPLATE_INFO_RESET_TABLE_COMBINATIONS',
  'TEMPLATE_INFO_RESET_TEMPLATE_INFOS',
  'TEMPLATE_INFO_RESET_TEMPLATE_TABLES',
  'TEMPLATE_INFO_RESET_TEMPLATE_TABLE_COMBINATIONS',
  'TEMPLATE_INFO_UPDATE',
  'TEMPLATE_INFO_DELETE',
  'TEMPLATE_INFO_SAVE_ALL',
  'TEMPLATE_INFO_UI_STATE_BATCH_REMOVE',
  'TEMPLATE_INFO_UI_STATE_UPDATE_FILTER',
  'TEMPLATE_INFO_UI_STATE_UPDATE_TEMPLATE',
  'TEMPLATE_INFO_UI_STATE_ADD_COMPLETE_TEMPLATE_INFO',
  'TEMPLATE_INFO_UI_STATE_ADD_TEMPLATE_INFO',
  'TEMPLATE_INFO_UI_STATE_DELETE_TEMPLATE_INFO',
  'TEMPLATE_INFO_UI_STATE_PLACE_HOLDS',
  'TEMPLATE_INFO_UI_STATE_REMOVE_HOLDS',
  'TEMPLATE_INFO_UI_STATE_UPDATE_TEMPLATE_INFO',
  'TEMPLATE_INFO_UI_STATE_BATCH_UPDATE_TEMPLATE_INFO',
  'TEMPLATE_INFO_UI_STATE_UPDATE_TICKET_PRICE',
  'TEMPLATE_INFO_UI_STATE_TABLE_GROUP_ADD',
  'TEMPLATE_INFO_UI_STATE_TABLE_GROUP_REMOVE',
  'TEMPLATE_INFO_SET_TABLES_FULLY_FLEXED',
  'TEMPLATE_INFO_SET_TABLE_OFFERED_ONLINE',
  'TEMPLATE_INFO_SET_TABLE_COMBINATION_OFFERED_ONLINE',
  'TEMPLATE_INFO_SET_FULLY_FLEXED_TICKET_TYPE',
  'TEMPLATE_INFO_SET_TABLES_AUTO_RELEASE_ENABLED',
  'TEMPLATE_INFO_SET_TABLES_BLOCKS',
  'TEMPLATE_INFO_SET_TABLES_HOLDS',
  // SOLD, AVAILABLE, etc
  'TICKET_GROUP_PURCHASE_STATES_FETCH_ALL',
  // Texting
  'TEXT_MESSAGING_CONFIG_FETCH',
  'TEXT_MESSAGING_UPSERT',
  // Turn times
  'TURN_TIMES_FETCH_ALL',
  'TURN_TIMES_FETCH_FOR_SERVICE_DAY',
  'TURN_TIMES_UPDATE',
  'TURN_TIMES_REPLACE_ALL',
  // Waitlist Awesomeness
  'WAITLIST_FETCH_FOR_TICKET_GROUP',
  'ONLINE_WALKIN_WAITLIST_TOGGLE',
  // Constants for creating or editing templates
  'ONE_TEMPLATE_UPDATE',

  'GENERATE_TEMPLATE',
  // Apply Template
  'APPLY_TEMPLATE',
  'APPLY_CHECK_TEMPLATE',
  'CLEAR_TEMPLATE',
  'CLEAR_APPLY_TEMPLATE_WARNINGS',

  // Guest Group
  'GUEST_GROUP_ADD',
  'GUEST_GROUP_ADD_EMAILS',
  'GUEST_GROUP_BLUR_FILTER',
  'GUEST_GROUP_CLEAR_FILTER',
  'GUEST_GROUP_DELETE',
  'GUEST_GROUP_DESELECT',
  'GUEST_GROUP_FETCH_ALL',
  'GUEST_GROUP_FETCH_USERS',
  'GUEST_GROUP_FOCUS_FILTER',
  'GUEST_GROUP_REMOVE_EMAIL',
  'GUEST_GROUP_SELECT',
  'GUEST_GROUP_SET_FILTER',
  'GUEST_GROUP_UPDATE',
  'GUEST_GROUP_VIEW_PAGE',

  'VERIFICATION_CHECK',

  // Table Management actions
  'TABLES_FETCH_ALL',
  'TABLES_FETCH_ARCHIVED',
  'TABLES_ADD',
  'TABLES_DELETE',
  'TABLES_SELECT_ROOM',
  'TABLES_UPDATE',
  'TABLECOMBINATION_FETCH_ALL',
  'TABLECOMBINATION_CREATE',
  'TABLECOMBINATION_DELETE',
  'TABLES_RENAME_ROOM',

  'TOCK_BANK_ACCOUNT_FETCH',
  'TOCK_BANK_ACCOUNT_UPDATE',
  'TOCK_BANK_ACCOUNT_VERIFY',
  'BANK_ACCOUNT_CLEAR',
  'BANK_ACCOUNT_SEARCH',

  //Tos
  'DOWNLOAD_TOS',

  // Service Config actions
  'BUSINESS_DEFINED_STATE_LIST_FETCH',
  'BUSINESS_DEFINED_STATE_INSERT',
  'BUSINESS_DEFINED_STATE_UPDATE',
  'BUSINESS_DEFINED_STATE_DELETE',
  'SERVICE_CONFIG_FETCH',

  // UI
  'UI_SET_ARCHIVED_SUPPLEMENTS',
  'UI_SET_ARCHIVED_SUPPLEMENT_GROUPS',
  'UI_SET_EXPERIENCE_FILTER',
  'UI_SET_TEMPLATE_FILTER',
  'UI_TOGGLE_BUSINESS_SWITCHER_MODAL',
  'UI_TOGGLE_CHECKIN_DATE_SWITCHER_MODAL',
  'UI_TOGGLE_DELIVERY_DATE_SWITCHER_MODAL',
  'UI_TOGGLE_CLEAR_TEMPLATES_MODAL',
  'UI_TOGGLE_DEVICE_STATUS_MODAL',
  'UI_TOGGLE_RELEASES_MODAL',
  'UI_TOGGLE_UPCOMING_CHANGES_MODAL',
  'UI_TOGGLE_GLOBAL_SEARCH_MODAL',
  'UI_TOGGLE_HELP_CENTER_MODAL',
  'UI_TOGGLE_KEYBOARD_SHORTCUTS_MODAL',
  'UI_SET_HELP_CENTER_TOPIC',
  'UI_URGENT_SUPPORT_MODAL',
  'UI_TOGGLE_WAITLIST_REPORT_ROW_MODAL',
  'UI_SET_CONTROL_PANEL_HEADING',
  'UI_AVAILABILITY_CLEAR_PARAMS',
  'UI_AVAILABILITY_PANEL_SHOW',
  'UI_AVAILABILITY_PANEL_HIDE',
  'UI_AVAILABILITY_FILTERS_SHOW',
  'UI_AVAILABILITY_FILTERS_HIDE',
  'UI_PACING_PANEL_SHOW',
  'UI_PACING_PANEL_HIDE',
  'UI_PACING_PANEL_TAB_UPDATE',
  'UI_SELF_ONBOARDING_HELP_OPEN',
  'UI_SELF_ONBOARDING_HELP_CLOSE',

  // Webhooks
  'WEBHOOK_ENDPOINT_FETCH_ALL',
  'WEBHOOK_ENDPOINT_INSERT',
  'WEBHOOK_ENDPOINT_UPDATE',
  'WEBHOOK_ENDPOINT_DELETE',

  // Persisted UI actions in local storage
  'PERSISTED_UI_TOGGLE_MOBILE_MODE',

  'WAITLIST_DELETE',

  // Payout reports
  'FETCH_PAYOUTS_FOR_REPORT',
  'SET_PAYOUTS_REPORT_DATE_RANGE',

  // Invoices
  'INVOICE_FETCH_ALL',
  'INVOICE_DOWNLOAD',

  // Updated Terms of Service screen
  'UPDATED_TERMS_OF_SERVICE_FETCH',
  // Do nothing action
  'NULL',

  // Unified Calendar and Service Filter Actions
  'CLOSE_RESERVATIONS_FILTER',
  'OPEN_RESERVATIONS_FILTER',
  'UPDATE_FILTER_BY_VISIT_TAGS',
  'UPDATE_FILTER_BY_GUEST_TAGS',
  'UPDATE_FILTER_BY_OFFERINGS',
  'UPDATE_FILTER_BY_PARTY_SIZE',
  'UPDATE_FILTER_BY_SUPPLEMENTS',
  'UPDATE_FILTER_BY_EDITED_STATUS',
  'UPDATE_FILTER_BY_STATUS',
  'UPDATE_FILTER_BY_UNANSWERED',
  'SET_FILTER_BY_OFFERING_TYPE',

  // New Image upload stuff
  'IMAGE_UPLOAD',
  'IMAGE_UPDATE',
  'IMAGE_UPSERT_BUSINESS_IMAGE',
  'IMAGE_DELETE_BUSINESS_IMAGE',
  'IMAGE_FETCH_ALL_BUSINESS_IMAGE',
  'IMAGE_ADD_IMAGES_TO_BE_CROPPED',
  'IMAGE_REMOVE_IMAGE_TO_BE_CROPPED',
  'IMAGE_FETCH_ALL_BUSINESS_PROFILE_IMAGES',
  'IMAGE_UPSERT_BUSINESS_PROFILE_IMAGES',
  'IMAGE_FETCH_ALL_TICKET_TYPE_IMAGES',
  'IMAGE_UPSERT_TICKET_TYPE_IMAGES',

  // Reservation Page Actions
  'RESERVATIONS_SET_QUICKACTIONS_AVAILABLE',
  'RESERVATIONS_SET_MOBILE_QUICKACTIONS_AVAILABLE',
  'RESERVATIONS_SET_SHOW_ACTIONS_MODAL',

  // Inventory Audit Log
  'INVENTORY_AUDIT_LOG',
  'INVENTORY_AUDIT_LOG_DONE',
  'INVENTORY_AUDIT_LOG_STARTING',
  'INVENTORY_AUDIT_LOG_FAILED',
  'INVENTORY_AUDIT_LOG_OPEN_MODAL',
  'INVENTORY_AUDIT_LOG_CLOSE_MODAL',

  // Facebook business extension
  'FACEBOOK_BUSINESS_EXTENSION',
  'FACEBOOK_BUSINESS_EXTENSION_APP_STORE_LOGIN',
  'FACEBOOK_BUSINESS_EXTENSION_APP_STORE_LOGIN_STARTING',
  'FACEBOOK_BUSINESS_EXTENSION_APP_STORE_LOGIN_FAILED',
  'FACEBOOK_BUSINESS_EXTENSION_APP_STORE_LOGIN_DONE',
  'FACEBOOK_BUSINESS_EXTENSION_UNINSTALL',

  // Native app message for telemetry
  'GET_NATIVE_VERSIONS',

  // Rebalancing purchases to tables
  'REBALANCING_FORCE',

  // UJET
  'UJET_AUTHENTICATION',
  'UJET_AUTHENTICATION_DONE',
  'UJET_AUTHENTICATION_STARTING',
  'UJET_AUTHENTICATION_FAILED',
  'UJET_INSTANCE_INITIALIZED',

  // Integrations
  'INTEGRATION_TAGS',
  'COMMERCE7_LIST_LOCATIONS',
  'TRIPLESEAT_LIST_LOCATIONS',

  // Viewing a past invoice on Stripe
  'STRIPE_INVOICE_URL',
]);
